export default __webpack_public_path__ + "img/rank2tt-abdaeaee.png";